// extracted by mini-css-extract-plugin
module.exports = {"datascitab":"DataScience_datascitab__1sRlM","pay":"DataScience_pay__vc-BZ"};